export const ProductTestimonialsPTBRTranslations = {
  productTestimonialsTitle: 'O que nossos clientes estão dizendo',
  productTestimonialClientAlt: 'Foto do cliente',
};
